import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const EndocrinologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.3569 40C80.3569 61.8153 62.6722 79.5 40.8569 79.5C19.0417 79.5 1.35693 61.8153 1.35693 40C1.35693 18.1848 19.0417 0.5 40.8569 0.5C62.6722 0.5 80.3569 18.1848 80.3569 40Z'
    />
    <path d='M38.5 31.6667H43.5V33.3334H38.5V31.6667Z' fill='#F0915A' />
    <path
      d='M51 33.3333H31C28.2385 33.3333 26 35.5718 26 38.3333V44.9999H31V64.9999H39.3333V63.3333H42.6667V64.9999H51V44.9999H56V38.3333C56 35.5718 53.7615 33.3333 51 33.3333Z'
      fill='#FAB991'
    />
    <path
      d='M31.0003 41.6667V45.0001H29.8892V42.7779C29.8892 42.1642 30.3867 41.6667 31.0003 41.6667Z'
      fill='#F0915A'
    />
    <path
      d='M43.7776 61.6667V65.0001H42.6665V62.7779C42.6665 62.1642 43.164 61.6667 43.7776 61.6667Z'
      fill='#F0915A'
    />
    <path
      d='M38.2222 61.6667V65.0001H39.3333V62.7779C39.3333 62.1642 38.8358 61.6667 38.2222 61.6667Z'
      fill='#F0915A'
    />
    <path
      d='M51 41.6667V45.0001H52.1111V42.7779C52.1111 42.1642 51.6136 41.6667 51 41.6667Z'
      fill='#F0915A'
    />
    <path
      d='M39.3332 15H38.4999C34.818 15 31.8332 17.9848 31.8332 21.6667V23.3333C31.0661 23.3333 30.4443 23.9552 30.4443 24.7222V25.2777C30.4443 26.0448 31.0661 26.6666 31.8332 26.6666V29.1666C31.8332 30.5473 32.9525 31.6666 34.3332 31.6666H41.8332C42.7536 31.6666 43.4999 32.4127 43.4999 33.3332V28.3332C44.8806 28.3332 45.9999 27.214 45.9999 25.8332V21.6667C45.9999 17.9848 43.0151 15 39.3332 15Z'
      fill='#FAB991'
    />
    <path
      d='M38.9167 16.6667C35.9251 16.6667 33.5 19.0919 33.5 22.0834C33.5 22.7737 34.0597 23.3334 34.75 23.3334H39.3333C39.3333 24.7141 40.4526 25.8334 41.8333 25.8334C43.2141 25.8334 44.3333 24.7141 44.3333 23.3334V22.0834C44.3333 19.0919 41.9082 16.6667 38.9167 16.6667Z'
      fill='#F0915A'
    />
    <path
      d='M38.0835 24.5833C38.7739 24.5833 39.3335 24.0236 39.3335 23.3333C39.3335 22.6429 38.7739 22.0833 38.0835 22.0833C37.3931 22.0833 36.8335 22.6429 36.8335 23.3333C36.8335 24.0236 37.3931 24.5833 38.0835 24.5833Z'
      fill='#F05A4B'
    />
    <path
      d='M41.8333 35.0001C41.8333 35.4603 41.4602 35.8334 41 35.8334C40.5398 35.8334 40.1667 35.4603 40.1667 35.0001C40.1667 34.5399 39.7935 34.1667 39.3333 34.1667C38.8731 34.1667 38.5 34.5399 38.5 35.0001V36.6667C38.5 37.127 38.8731 37.5001 39.3333 37.5001C39.7935 37.5001 40.1667 37.127 40.1667 36.6667H41.8333C41.8333 37.127 42.2065 37.5001 42.6667 37.5001C43.1269 37.5001 43.5 37.127 43.5 36.6667V35.0001C43.5 34.5399 43.1269 34.1667 42.6667 34.1667C42.2065 34.1667 41.8333 34.5399 41.8333 35.0001Z'
      fill='#F05A4B'
    />
    <path
      d='M41.4165 43.3333C42.1068 43.3333 42.6665 42.7736 42.6665 42.0833V40H42.2498C41.0992 40 40.1665 40.9327 40.1665 42.0833C40.1665 42.7736 40.7262 43.3333 41.4165 43.3333Z'
      fill='#FAA032'
    />
    <path
      d='M40.5835 43.3333C39.8932 43.3333 39.3335 42.7736 39.3335 42.0833V40H39.7502C40.9008 40 41.8335 40.9327 41.8335 42.0833C41.8335 42.7736 41.2738 43.3333 40.5835 43.3333Z'
      fill='#FAD741'
    />
    <path
      d='M37.6668 50.5774V50.2558C38.3304 49.8714 38.778 49.1554 38.778 48.3333C38.778 47.106 37.7831 46.1111 36.5558 46.1111C35.3284 46.1111 34.3335 47.106 34.3335 48.3333V52.4999C34.3335 53.7272 35.3284 54.7221 36.5557 54.7221C37.783 54.7221 38.7779 53.7272 38.7779 52.4999C38.778 51.6779 38.3304 50.9618 37.6668 50.5774Z'
      fill='#F0915A'
    />
    <path
      d='M44.3333 50.5774V50.2558C43.6698 49.8714 43.2222 49.1554 43.2222 48.3333C43.2222 47.106 44.2171 46.1111 45.4444 46.1111C46.6716 46.1111 47.6665 47.106 47.6665 48.3333V52.4999C47.6665 53.7272 46.6716 54.7221 45.4444 54.7221C44.2171 54.7221 43.2222 53.7272 43.2222 52.4999C43.2222 51.6779 43.6698 50.9618 44.3333 50.5774Z'
      fill='#F0915A'
    />
    <path
      d='M37.1109 46.6667H35.722C35.4151 46.6667 35.1665 46.418 35.1665 46.1112C35.1665 45.8043 35.4153 45.5557 35.722 45.5557H37.1109C37.4178 45.5557 37.6664 45.8044 37.6664 46.1112C37.6664 46.418 37.4176 46.6667 37.1109 46.6667Z'
      fill='#F05A4B'
    />
    <path
      d='M39.3332 49.1667C38.3866 49.1667 37.6244 49.9558 37.6683 50.9121C37.7074 51.7608 38.4057 52.4591 39.2545 52.4982C40.2107 52.5423 40.9999 51.78 40.9999 50.8334H42.6665C43.1268 50.8334 43.4999 50.4603 43.4999 50.0001C43.4999 49.5399 43.1268 49.1667 42.6665 49.1667H39.3332Z'
      fill='#FAD741'
    />
    <path
      d='M46.2779 46.6667H44.889C44.5822 46.6667 44.3335 46.418 44.3335 46.1112C44.3335 45.8043 44.5822 45.5557 44.889 45.5557H46.2779C46.5846 45.5557 46.8334 45.8044 46.8334 46.1112C46.8334 46.418 46.5846 46.6667 46.2779 46.6667Z'
      fill='#F05A4B'
    />
    <path
      d='M39.6112 61.6667C39.151 61.6667 38.7778 61.2936 38.7778 60.8334V60.0001C38.7778 59.5399 39.151 59.1667 39.6112 59.1667C40.0714 59.1667 40.4445 59.5399 40.4445 60.0001V60.8334C40.4445 61.2936 40.0714 61.6667 39.6112 61.6667Z'
      fill='#F05A4B'
    />
    <path
      d='M42.389 61.6667C41.9288 61.6667 41.5557 61.2936 41.5557 60.8334V60.0001C41.5557 59.5399 41.9288 59.1667 42.389 59.1667C42.8492 59.1667 43.2223 59.5399 43.2223 60.0001V60.8334C43.2223 61.2936 42.8493 61.6667 42.389 61.6667Z'
      fill='#F05A4B'
    />
  </svg>
));
EndocrinologyIcon.displayName = 'EndocrinologyIcon';

export default EndocrinologyIcon;
